document
  .querySelectorAll(".product-galley-usp-badge-content")
  .forEach((content) => {
    content.addEventListener("click", () => {
      content
        .closest(".product-gallery__media")
        .classList.toggle("usp-badge-modal-show");
    });
  });

const productImageInfo = document.querySelectorAll(".product__image-info");

productImageInfo.forEach(item => {
  const content = item.querySelector(".product__image-info-content")
  const contentInfo = item.querySelector(".product__image-info-text")
  
  content.addEventListener("click", function () {
    this.parentElement.classList.toggle('active');
    contentInfo.classList.toggle('active');
  })
})


